import React from 'react';
import { useParams } from 'react-router-dom';
import { Grid, SolidCard } from '@exxonmobil/react-unity';
import styled from 'styled-components';
import { DomainValidation } from '../../common/types/DomainTypes';
import { getStatusColor } from '../../common/utils/getColor';
import { numberMillify, percentNumberFormat } from '../../common/utils/numberUtil';
import OverviewTileLoading from './OverviewTileLoading';

const OverviewTile = ({ domains, isLoading }: { domains: DomainValidation[]; isLoading: boolean }) => {
  const { id } = useParams();

  if (isLoading) {
    return <OverviewTileLoading />;
  }
  return (
    <>
      {domains.map(
        (domain) =>
          domain.id.toString() === id && (
            <Grid key={domain.id} variant="4-up">
              <Grid.Item>
                <Tile bgColor={getStatusColor(domain.status)} color="white" header="CURRENT STATUS" value="AVAILABLE" />
              </Grid.Item>
              <Grid.Item>
                <Tile
                  bgColor="white"
                  color="black"
                  header="AVAILABILITY (YTD)"
                  value={percentNumberFormat(domain.availability)}
                />
              </Grid.Item>
              <Grid.Item>
                <Tile
                  bgColor="white"
                  color="black"
                  header="EVENT USAGE (YTD)"
                  value={numberMillify(domain.eventUsage)}
                />
              </Grid.Item>
              <Grid.Item>
                <Tile bgColor="white" color="black" header="API USAGE (YTD)" value={numberMillify(domain.apiUsage)} />
              </Grid.Item>
            </Grid>
          )
      )}
    </>
  );
};

const Tile = ({ bgColor, color, header, value }: { bgColor: string; color: string; header: string; value: string }) => (
  <StyledSolidCard>
    <SolidCard.Body style={{ backgroundColor: bgColor, color }}>
      <SolidCard.Body.Kicker>{header}</SolidCard.Body.Kicker>
      <SolidCard.Body.Title>{value}</SolidCard.Body.Title>
    </SolidCard.Body>
  </StyledSolidCard>
);

const StyledSolidCard = styled(SolidCard)`
  border-color: white;
`;

export default OverviewTile;
